<template>
  <div class="Page Login">
    <div class="loginbox">
      <h3 class="subtitle">Base des données</h3>
      <div class="box">
        <form name="login-form" @submit.prevent="send">
          <div class="field">
            <label class="label">Identifiant</label>
            <input type="text" class="input" name="login" v-model="login" />
          </div>
          <div class="field">
            <label class="label">Mot de passe</label>
            <input
              type="password"
              class="input"
              name="password"
              v-model="password"
              @keyup.enter="send"
            />
          </div>
          <p class="has-text-danger" v-show="hasError">Raté.</p>
          <hr />
          <div class="field">
            <button
              class="button is-light"
              :class="[loading ? 'is-loading' : '']"
              @click="send"
              :disabled="password.length < 6"
            >
              Entrer
            </button>
          </div>
          <hr />
          <router-link :to="'/auth/forgot'" class="is-size-7"
            >mot de passe oublié ?</router-link
          >
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { types as t } from "../../store/actions/auth";

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      login: "",
      password: "",
      hasError: false
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  },
  methods: {
    async send() {
      this.loading = true;
      await this.$root.$d();
      try {
        await this.$store.dispatch(t.LOGIN, {
          login: this.login,
          password: this.password
        });
        this.hasError = false;
        this.$router.push("/home");
        // eslint-disable-next-line
      } catch (e) {
        this.hasError = true;
        throw e;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.Page.Login {
  width: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .loginbox {
    width: 100%;
    max-width: 290px;
  }
}
</style>
